import React from 'react';

import { useSelector } from 'react-redux';
import UserDetails from './UserDetails';

const UserList = () => {
    const { users } = useSelector((state) => state.admin);

    return (
        <>
            {users.map((user) => (
                <UserDetails id={user._id} key={user._id} />
            ))}
        </>
    );
};

export default UserList;
